import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-74" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 text-center" data-id="element-75" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto max-w-2xl pt-2 font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" data-id="element-76" data-mp="4n1j0kwg00pc">
          Turn AI into your <span className="text-grape" data-id="element-77" data-mp="xano5xlbjdeb">practical electrical engineering</span> assistant
        </h1>

        <p className="mx-auto max-w-2xl pb-3 pt-4 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-plum/60 sm:text-sm" data-id="element-78" data-mp="sb1a5lxo1t4g">
          The complete AI prompt system to structure engineering tasks, organize technical calculations, streamline documentation, and speed up your daily workflow by 80%
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-79" data-mp="3825xcnx6o3kb">
          <img src="https://cdn.magicpatterns.com/uploads/rzs7JwD5eafndSZ9HMiQsR/Kit_de_Tablets_Sigma_Smart_para_Ingenieria,Moda.webp" alt="100+ AI Prompts for Electrical Engineers™ — 6-Volume Visual System + 4 Professional Bonuses" width={1536} height={1024} sizes="(min-width: 640px) 640px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[640px] object-contain mix-blend-multiply" data-id="element-80" data-mp="39auqrc9b5kwp" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-81" data-mp="2qhqtlgwvspxc">
          100+ AI PROMPTS FOR ELECTRICAL ENGINEERS™ · 6-Volume Visual System + 4 Professional Bonuses · The SIGMA SMART™ Method · ⭐ 4.9 (Over 500 satisfied users) · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-82" data-mp="2ljz22o05f5to">
          <CTAButton href="#pricing" data-id="element-83" data-mp="s2b89zesml5o">See the 100+ AI Prompts for Electrical Engineers now</CTAButton>

          <p className="mx-auto mt-5 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-84" data-mp="nb1jf112jluu">
            <span className="font-bold text-plum" data-id="element-85" data-mp="iboywmxo6qvf">THE PRACTICAL AI TOOLKIT FOR ELECTRICAL ENGINEERING PROFESSIONALS.</span>{' '}
            Designed for Electrical Engineers, Electrical Technicians, Project Engineers, Maintenance Professionals,
            and Engineering Consultants who want to use AI more effectively in their daily technical work.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-86" data-mp="15zq69sj44199">
            Electrical Design · Power Systems · Calculations · Automation · Troubleshooting · Technical Documentation
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-87" data-mp="3ltgm7o0v2mna">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-left text-xs font-semibold text-plum/80" data-id="element-88" data-mp="3hq248rtd3w77">
                <Icon className="h-3.5 w-3.5 shrink-0 text-grape" data-id="element-89" data-mp="21bpjt8ta5ey1" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-90" data-mp="267wlgpen84a6">
            - Everything you need in one organized engineering AI toolkit -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-91" data-mp="2fz0znmwhvl3y">
          🔥 Limited-Time Offer · Price will return to $54 soon
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-92" data-mp="2u03lbyjkutec">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="umzf3mkkro34" />
          11 users are viewing this toolkit right now
        </p>
      </div>
    </header>;
}